const translations = {
    asFlown: 'As Flown'
};

export default translations;
